import { getLogger } from '../../logging/logger';

const logger = getLogger('Panel');
const CONFIG = {
	fg: '#0ff',
	bg: '#002',
	width: '80',
	height: '48',
	font: 'bold Helvetica,Arial,sans-serif',
	textBaseline: 'top',
	min: Infinity,
	max: 0,
	PR: Math.round(window.devicePixelRatio || 1),
};

export default class Panel {
	constructor(name, config) {
		this.name = name;
		Object.assign(this, CONFIG, config);

		this.WIDTH = 80 * this.PR;
		this.HEIGHT = 48 * this.PR;
		this.TEXT_X = 3 * this.PR;
		this.TEXT_Y = 2 * this.PR;
		this.GRAPH_X = 3 * this.PR;
		this.GRAPH_Y = 15 * this.PR;
		this.GRAPH_WIDTH = 74 * this.PR;
		this.GRAPH_HEIGHT = 30 * this.PR;

		this.canvas = document.createElement('canvas');
		this.canvas.classList.add(name);
		this.canvas.width = this.WIDTH;
		this.canvas.height = this.HEIGHT;
		this.canvas.style.cssText = `width:${this.width}px;height:${this.height}px`;

		this.context = this.canvas.getContext('2d');
		this.context.font = `${this.font} ${9 * this.PR}px`;
		this.context.textBaseline = 'top';

		this.context.fillStyle = this.bg;
		this.context.fillRect(0, 0, this.WIDTH, this.HEIGHT);

		this.context.fillStyle = this.fg;
		this.context.fillText(name, this.TEXT_X, this.TEXT_Y);
		this.context.fillRect(this.GRAPH_X, this.GRAPH_Y, this.GRAPH_WIDTH, this.GRAPH_HEIGHT);

		this.context.fillStyle = this.bg;
		this.context.globalAlpha = 0.9;
		this.context.fillRect(this.GRAPH_X, this.GRAPH_Y, this.GRAPH_WIDTH, this.GRAPH_HEIGHT);

		this.dom = this.canvas;
	}

	update(value, maxValue) {
		logger.debug('[update]', { value, maxValue });

		this.min = Math.min(this.min, value);
		this.max = Math.max(this.max, value);

		this.context.fillStyle = this.bg;
		this.context.globalAlpha = 1;
		this.context.fillRect(0, 0, this.WIDTH, this.GRAPH_Y);
		this.context.fillStyle = this.fg;
		this.context.fillText(
			`${Math.round(value)} ${this.name} (${Math.round(this.min)}-${Math.round(this.max)})`,
			this.TEXT_X,
			this.TEXT_Y,
		);

		this.context.drawImage(
			this.canvas,
			this.GRAPH_X + this.PR,
			this.GRAPH_Y,
			this.GRAPH_WIDTH - this.PR,
			this.GRAPH_HEIGHT,
			this.GRAPH_X,
			this.GRAPH_Y,
			this.GRAPH_WIDTH - this.PR,
			this.GRAPH_HEIGHT,
		);

		this.context.fillRect(
			this.GRAPH_X + this.GRAPH_WIDTH - this.PR,
			this.GRAPH_Y,
			this.PR,
			this.GRAPH_HEIGHT,
		);

		this.context.fillStyle = this.bg;
		this.context.globalAlpha = 0.9;
		this.context.fillRect(
			this.GRAPH_X + this.GRAPH_WIDTH - this.PR,
			this.GRAPH_Y,
			this.PR,
			Math.round((1 - value / maxValue) * this.GRAPH_HEIGHT),
		);
	}
}
